<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{ name: string; size?: number; square?: boolean }>(), { size: 32 })

const initials = computed(() => {
  const parts = props.name.trim().split(/\s+/).filter(Boolean)
  const first = parts[0]?.[0] ?? ''
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : (parts[0]?.[1] ?? '')
  return (first + last).toUpperCase()
})
</script>

<template>
  <span
    aria-hidden="true"
    class="ui-avatar"
    :class="{ 'ui-avatar--square': square }"
    :style="{ width: `${size}px`, height: `${size}px`, minWidth: `${size}px`, fontSize: `${Math.max(11, Math.round(size / 2.7))}px` }"
    >{{ initials }}</span
  >
</template>

<style scoped>
.ui-avatar {
  border-radius: var(--radius-full);
  background: var(--accent);
  color: var(--on-accent);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: var(--weight-semibold);
  letter-spacing: 0.02em;
}
.ui-avatar--square {
  border-radius: var(--radius-md);
  font-weight: var(--weight-bold);
}
</style>
